export enum SystemControlSubType {
  ORDERMONITOR_FEED_PANIC,
  ORDERMONITOR_CHANGE_PANIC,
  AUTO_ORDER_PANIC,
}

export namespace SystemControlSubType {
  let elements = [
    SystemControlSubType.ORDERMONITOR_FEED_PANIC,
    SystemControlSubType.ORDERMONITOR_CHANGE_PANIC,
    SystemControlSubType.AUTO_ORDER_PANIC,
  ];
  let alias = "com.bcdfx.model.SystemControlSubType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
